import { FlexContainer, Img } from "../../design";
import React, { useEffect, useState } from "react";
import { CheckCircleFilled, CloseOutlined, MinusCircleOutlined, UserOutlined } from '@ant-design/icons';
import { Card, Collapse, Segmented, Tooltip } from "antd";
import VISA from "../../assets/imgs/VISA.svg";
import DISCOVER from "../../assets/imgs/DISCOVER.svg";
import MASTER from "../../assets/imgs/MASTER_CARD.svg";
import SWIREPAY_FULL_LOGO from "../../assets/imgs/swirepay-logo.svg";
import AMEX from "../../assets/imgs/amex-icon.svg";
import INSTANT_PAYMENT_IMG from "../../assets/imgs/INSTANT_PAYMENT.svg";
import BANK_PAYMENT_IMG from "../../assets/imgs/BANK_PAYMENT.svg";
import { Button } from "antd";
import { paymentMethodsHelper, omitOtherPayments, bankPaymentMethods } from "./Components/helper";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateStatus } from "../../redux/customerDetailsInfo";
import CustomerDetails from "./Components/CustomerDetails";
import './Components/custom-styles.css';
import { setDirectoryAccessToken, setSavedPaymentsClose } from "../../redux/directory";

type Props = {
  tabs: Array,
  tabPanels: Array,
  paymentTypes: string,
  id: number,
  upiDown: Boolean,
  getCurrentTab: Function,
};

const getCheckedIcons = (value) => {
  return value ? <CheckCircleFilled style={{ color: "#34A853", fontSize: "20px" }} /> 
               : <MinusCircleOutlined style={{ color: "#AAAAAA", fontSize: "20px" }} />
};

const PaymentExpandableRows = (props: Props) => {
  const { tabs, tabPanels, id, upiDown, applePayment, isApplePay, getCurrentTab, supportedPaymentTypes } = props;
  
  const { isMobileView } = useSelector((store) => store.appConfigInfo); 
  const { directoryEligibility, savedPaymentsClose } = useSelector((store) => store.directory);
  const [otherPayment, setOtherPayment] = useState(null);
  const [checked, setChecked] = useState(null);
  const [savedPaymentChecked, setSavedPaymentChecked] = useState(false);
  const [bankPayment, setBankPayment] = useState();
  const [customerExist, setCustomerExist] = useState(false);
  const showAmexCard = supportedPaymentTypes?.includes('AMEX_NOT_PRESENT');
  const dispatch = useDispatch();

  const ossatId = [
    "eventpageorderlink-94d9318db7414a2bbbf5c57a8a593277",
  ];

  useEffect(() => {
    if(savedPaymentsClose){
      setSavedPaymentChecked(false);
      dispatch(setSavedPaymentsClose(false));
    }
  }, [dispatch, savedPaymentsClose]);

  const paymentBanks = React.useMemo(() => {
    if (!Array.isArray(tabs) || !Array.isArray(tabPanels)) {
      return [];
    }

    const tabPanelsIds = tabPanels.map((item) => item?.id);

    const filterPaymentBankTabs = tabs.filter(
      (item) =>
        bankPaymentMethods.includes(item) &&
        tabPanelsIds.includes(item)
    );

    const fixedOrder = ["ACH_LEGACY", "X_ACH", "ZIP_ACH", "RAPID_ACH"];

    return fixedOrder.filter((item) =>
      filterPaymentBankTabs.includes(item)
    );
  }, [tabs, tabPanels]);

  useEffect(() => {
    if (paymentBanks?.length > 0 && (!bankPayment || !paymentBanks.includes(bankPayment))) {
      setBankPayment(paymentBanks[0]);
    }
  }, [paymentBanks, bankPayment]);

  const tabMap = new Map(tabPanels.map((t) => [t.id, t.children]));

  const tabIndexStore = (value) => {
    let methodKey = value;

    // If it's a number (bank collapse index), resolve actual payment method
    if (value === 'BANK') {
      methodKey = bankPayment; // get actual key like "ACH_LEGACY"
    }

    // Get label (fallback to methodKey if not found in helper)
    const label = paymentMethodsHelper[methodKey]?.key || methodKey;
    
    if(getCurrentTab) {
      getCurrentTab(label);
    };
    localStorage.setItem(`${id}-tab-name`, label);
  };
  
  if (!customerExist) {
    return (
      <Card
        title={
          <>
            <UserOutlined style={{ fontSize: '15px', color: '#FFFFFF' }} />
            <span className="ml-2" style={{ fontSize: '15px', fontWeight: '600', color: '#FFFFFF' }}>Customer Details</span>
          </>
        }
        headStyle={{
          backgroundColor: '#3E8BFF', color: '#fff', minHeight: '45px'
        }}
      >
        <CustomerDetails setCustomerExist={setCustomerExist} />
      </Card>
    )
  }

  return (
    <FlexContainer className={isMobileView ? "w-100 p-3 mt-3" : "w-100"} box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
      display="flow-root" backgroundColor="#fff" borderRadius="10px"
    >
      <FlexContainer justifyContent="space-between" alignItems="center" width="100%">
        <Img src={SWIREPAY_FULL_LOGO} style={{ marginBottom: '1rem', width: '10rem' }} />
        <Tooltip title="close">
          <CloseOutlined onClick={() => {
            setCustomerExist(false);
            setChecked(null);
            setSavedPaymentChecked(false);
            setOtherPayment(null);
            dispatch(setDirectoryAccessToken(null));
          }} />
        </Tooltip>
      </FlexContainer>
      {tabs.length > 0 && (tabs.filter((item) => !omitOtherPayments.includes(item)).length > 0 || (isApplePay && applePayment)) && (
        <Card title="Express Checkout" className="mb-3 express-payment-method-card" headStyle={{ backgroundColor: '#3E8BFF', color: '#fff', minHeight: '40px' }}>
          <FlexContainer className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "10px" }}>
            {tabs.length > 0 && tabs.filter((item) => !omitOtherPayments.includes(item)).map((item, index) => (
              <Button
                style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }} 
                type="ghost" disabled={item === 'UPI' && upiDown}
                onClick={() => { setOtherPayment(item); setChecked(false); dispatch(setUpdateStatus(true)); tabIndexStore(item); setSavedPaymentChecked(false); }}
              >
                <Img width="17px" src={paymentMethodsHelper[item]?.icon || INSTANT_PAYMENT_IMG} className="mr-2" /> {paymentMethodsHelper[item]?.label || item}
              </Button>
            ))}
            {isApplePay && applePayment && (
              <Button
                style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', paddingTop: '13px' }} 
                type="ghost" className="mb-3"
                onClick={() => { setOtherPayment('APPLE_PAY_US'); setChecked(false); tabIndexStore('APPLE_PAY_US'); setSavedPaymentChecked(false); dispatch(setUpdateStatus(true)); }}
              >
                <Img width="17px" src={paymentMethodsHelper['APPLE_PAY_US']?.icon} className="mr-2" /> {paymentMethodsHelper['APPLE_PAY_US']?.label}
              </Button>
            )}
            {otherPayment && (
              <div className='p-3 w-100 mb-2'>
                {tabMap.get(otherPayment)}
              </div>
            )}
          </FlexContainer>
        </Card>
      )}

      {directoryEligibility && (
        <Card title="Saved Payment Methods" className="mb-3 payment-method-card" headStyle={{ backgroundColor: '#3E8BFF', color: '#fff', minHeight: '40px' }}>
          <Collapse accordion activeKey={savedPaymentChecked}
            onChange={(value) => {
              setChecked(false); setOtherPayment(false); setSavedPaymentChecked(value); tabIndexStore('DIRECTORY');
            }}
          >
            <Collapse.Panel 
              key={1} 
              header={
                <>
                  <span className="ml-2" style={{ fontWeight: '600' }}>Click here to see saved payment methods</span>
                </>
              }
            >
              {savedPaymentChecked && tabMap.get('SAVED_PAYMENT_METHODS')}
            </Collapse.Panel>
          </Collapse>
        </Card>
      )}
      
      {(paymentBanks?.length > 0 || tabs?.includes('CARD')) && (
        <Card title="Select New Payment Method" className="mb-3 payment-method-card" headStyle={{ backgroundColor: '#3E8BFF', color: '#fff', minHeight: '40px' }} bodyStyle={{ padding: '0 !important' }}>
          <Collapse accordion activeKey={checked}
            onChange={(value) => {
              setChecked(value); setOtherPayment(false); dispatch(setUpdateStatus(true)); setSavedPaymentChecked(false);
              
              if (Array.isArray(value) && value.includes('CARD')) {
                tabIndexStore('CARD');
              }

              if (Array.isArray(value) && value.includes('BANK')) {
                tabIndexStore(bankPayment);
              }
            }}
          >
            {paymentBanks?.length > 0 && (
              <Collapse.Panel 
                key="BANK" 
                extra={!isMobileView && getCheckedIcons(Array.isArray(checked) && checked.includes('BANK'))} 
                header={
                  <>
                    <Img src={BANK_PAYMENT_IMG} style={{ marginBottom: '-5px' }} /> 
                    <span className="ml-2" style={{ fontWeight: '600' }}>Pay by Bank</span>
                  </>
                }
              >
                  <>
                    <Segmented
                      options={paymentBanks?.map((item) => ({
                        label: (
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <Img src={paymentMethodsHelper[item]?.icon} />
                            <span>{paymentMethodsHelper[item]?.label} {ossatId.includes(id) ? paymentMethodsHelper[item]?.subText : ''}</span>
                          </div>
                        ),
                        value: item,
                      }))}
                      onChange={(value) => {
                        setBankPayment(value);
                        tabIndexStore(value);
                      }}
                      className="full-width-segmented"
                    />
                    {bankPayment && (
                      <div key={bankPayment}>
                        {tabMap.get(bankPayment)}
                      </div>
                    )}
                  </>
              </Collapse.Panel>
            )}
            {tabs?.length > 0 && tabs?.filter((item) => item === 'CARD')?.map((item) => (
              <Collapse.Panel 
                key="CARD"
                extra={!isMobileView && (
                  <div className="d-flex align-items-center gap-8">
                    <Img src={VISA} /> 
                    <Img src={MASTER} />
                    <Img src={DISCOVER} />
                    {showAmexCard && <Img src={AMEX} />}
                    {!isMobileView && getCheckedIcons(Array.isArray(checked) && checked.includes('CARD'))}
                  </div>
                )} 
                header={
                  <>
                    <Img src={paymentMethodsHelper[item]?.icon} style={{ marginBottom: '-5px' }} /> 
                    <span className="ml-2" style={{ fontWeight: '600' }}>
                      {paymentMethodsHelper[item]?.label}
                    </span>
                  </>
                }
              >
                {tabMap.get(item)}
              </Collapse.Panel>
            ))}
          </Collapse>
        </Card>
      )}
    </FlexContainer>
  )
};

export default PaymentExpandableRows;
